interface PromoCodeItem {
  periodValue: number;
  code: string;
}

interface PromoPeriodPlan {
  planName: string;
  promoCode: PromoCodeItem[];
}

export const promoCodesByPeriod: PromoPeriodPlan[] = [
  {
    planName: 'starter',
    promoCode: [
      { periodValue: 1, code: 'STARTER1' },
      { periodValue: 3, code: 'STARTER3' },
      { periodValue: 6, code: 'STARTER6' },
      { periodValue: 12, code: 'STARTER12' }
    ]
  },
  {
    planName: 'lite',
    promoCode: [
      { periodValue: 1, code: 'LITE1' },
      { periodValue: 3, code: 'LITE3' },
      { periodValue: 6, code: 'LITE6' },
      { periodValue: 12, code: 'LITE12' }
    ]
  },
  {
    planName: 'advanced',
    promoCode: [
      { periodValue: 1, code: 'ADVANCED1' },
      { periodValue: 3, code: 'ADVANCED3' },
      { periodValue: 6, code: 'ADVANCED6' },
      { periodValue: 12, code: 'ADVANCED12' }
    ]
  }
];

/**
 * Gets the default promo code for a plan and period.
 *
 * @param planName - Name of the plan
 * @param periodValue - Period value in months
 * @param isFirstPayment - Whether this is the user's first payment
 * @returns Array containing the default promo code if applicable, empty array otherwise
 */
export const getPromoCode = (
  planName: string,
  periodValue: number,
  isFirstPayment: boolean
): string[] => {
  const promoCode =
    promoCodesByPeriod
      .find((plan) => plan.planName === planName)
      ?.promoCode.find((promo: any) => promo.periodValue === periodValue)
      ?.code ?? '';
  return promoCode ? [promoCode] : [];
  // return promoCode && isFirstPayment ? [promoCode] : [];
};

/**
 * Updates promo codes when the billing period changes.
 * Replaces default promo codes with the new period's promo code if available.
 *
 * @param promoCodes - Current list of applied promo codes
 * @param defaultPromoCodeInCurrentPromoCodes - The default promo code currently applied (if any)
 * @param promoCodeBySelectedPeriod - The new period's default promo code (if any)
 * @returns Updated list of promo codes
 */
export const getUpdatedPromoCodesForPeriod = (
  promoCodes: string[],
  defaultPromoCodeInCurrentPromoCodes: string | undefined,
  promoCodeBySelectedPeriod: string | undefined
): string[] => {
  if (defaultPromoCodeInCurrentPromoCodes) {
    // Remove old default promo code and add new one if available
    const withoutOldDefault = promoCodes.filter(
      (item) => item !== defaultPromoCodeInCurrentPromoCodes
    );
    return promoCodeBySelectedPeriod
      ? [...withoutOldDefault, promoCodeBySelectedPeriod]
      : withoutOldDefault;
  } else {
    // No old default, just use new default if available
    return promoCodeBySelectedPeriod ? [promoCodeBySelectedPeriod] : [];
  }
};
